import { useEffect, useRef, useState } from "react";
import Icon from "src/components/common/Icon";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectSelectedMonths } from "src/redux/shopping_cart/shopping_cart.selectors";
import { setSelectedMonths } from "src/redux/shopping_cart/shopping_cart.slice";
import {
    Container,
    DropdownList,
    LabelRow,
    Option,
    Trigger,
} from "./MonthPeriodSelect.styles";

const MONTH_OPTIONS = [
    { value: 1, label: "1 mes" },
    { value: 2, label: "2 meses" },
    { value: 3, label: "3 meses" },
    { value: 4, label: "4 meses" },
    { value: 5, label: "5 meses" },
    { value: 6, label: "6 meses" },
] as const;

const PLACEHOLDER = "Selecciona periodo";

const MonthPeriodSelect = () => {
    const dispatch = useAppDispatch();
    const selectedMonths = useAppSelector(selectSelectedMonths);
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const selectedOption = selectedMonths !== null
        ? MONTH_OPTIONS.find((o) => o.value === selectedMonths)
        : null;
    const displayLabel = selectedOption ? selectedOption.label : PLACEHOLDER;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    return (
        <Container ref={containerRef}>
            <LabelRow>
                <Icon icon="pcom-icon-calendar-empty" size={18} />
                <span className="period-label">Período:</span>
            </LabelRow>
            <Trigger type="button" onClick={() => setIsOpen((prev) => !prev)} aria-haspopup="listbox" aria-expanded={isOpen}>
                <span>{displayLabel}</span>
                <Icon
                    icon="pcom-icon-chevron-down"
                    size={16}
                    style={{ transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s ease" }}
                />
            </Trigger>
            {isOpen && (
                <DropdownList role="listbox">
                    {MONTH_OPTIONS.map((option) => (
                        <Option
                            key={option.value}
                            role="option"
                            aria-selected={selectedMonths !== null && option.value === selectedMonths}
                            $selected={selectedMonths !== null && option.value === selectedMonths}
                            onClick={() => {
                                dispatch(setSelectedMonths(option.value));
                                setIsOpen(false);
                            }}
                        >
                            {selectedMonths !== null && option.value === selectedMonths && (
                                <Icon icon="pcom-icon-circle-check-filled" size={18} />
                            )}
                            <span>{option.label}</span>
                        </Option>
                    ))}
                </DropdownList>
            )}
        </Container>
    );
};

export default MonthPeriodSelect;
